import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

export const getVendorExpert = createAsyncThunk(
  "vendorexperts/web-get-vendors-experts",
  async (filter, { rejectWithValue }) => {
    try {
      let query = `?type=${filter?.type || ""}`;

      if (filter?.state) query += `&state=${filter.state}`;
      if (filter?.district) query += `&district=${filter.district}`;
      if (filter?.search_name) {
        query += `&search_name=${encodeURIComponent(filter.search_name)}`;
      }
      // if (filter?.profession_id)
      //   query += `&profession_id=${filter.profession_id}`;
      if (filter?.see_all_status) {
        query += `&see_all_status=${filter.see_all_status}`;
      }

      const materialIds =
        filter?.material_id?.length > 0 ? filter.material_id : [0];

      materialIds.forEach((id, index) => {
        query += `&material_id[${index}]=${id}`;
      });

      const professionIds =
        filter?.profession_id?.length > 0 ? filter.profession_id : [];

      professionIds.forEach((id, index) => {
        query += `&profession_id[${index}]=${id}`;
      });

      const res = await GET(`${APIS.Vendor_Expert.Vendors_Experts}${query}`, {
        headers: {
          Authorization: `Bearer ${filter?.token}`,
        },
      });

      return res;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: error.message },
      );
    }
  },
);

export const VendorEnquiry = createAsyncThunk(
  "/vendor-enquiry",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Vendor_Expert.VendorEnquiry, data);

      if (res?.success === false) {
        return rejectWithValue(res);
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: error.message },
      );
    }
  },
);

export const ExpertEnquiry = createAsyncThunk(
  "/expert-enquiry",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Vendor_Expert.ExpertEnquiry, data);

      if (res?.success === false) {
        return rejectWithValue(res);
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: error.message },
      );
    }
  },
);

export const RateUs = createAsyncThunk(
  "/rate-us",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Vendor_Expert.RateUs, data);

      if (res?.success === false) {
        return rejectWithValue(res);
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: error.message },
      );
    }
  },
);

export const getVendorExpertList = createAsyncThunk(
  "vendorexperts/vendor-expert-history",
  async (filter, { rejectWithValue }) => {
    try {
      let query = `?type=${filter?.type || ""}`;

      const res = await GET(
        `${APIS.Vendor_Expert.getVendorExpertList}${query}`,
        {
          headers: {
            Authorization: `Bearer ${filter?.token}`,
          },
        },
      );

      return res;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: error.message },
      );
    }
  },
);

export const getVendorCustomerList = createAsyncThunk(
  "vendorexperts/vendor-customer-lead",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Vendor_Expert.getVendorCustomerList}`, {
        headers: {
          Authorization: `Bearer ${filter?.token}`,
        },
      });

      return res;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: error.message },
      );
    }
  },
);

export const getExpertCustomerList = createAsyncThunk(
  "vendorexperts/expert-customer-lead",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Vendor_Expert.getExpertCustomerList}`, {
        headers: {
          Authorization: `Bearer ${filter?.token}`,
        },
      });

      return res;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: error.message },
      );
    }
  },
);

export const Vendor_Call = createAsyncThunk(
  "/vendor-enquiry-call",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Vendor_Expert.Vendor_Call, data);

      if (res?.success === false) {
        return rejectWithValue(res);
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: error.message },
      );
    }
  },
);

export const getVendorCustomerHistory = createAsyncThunk(
  "vendorexperts/vendor-purchase-lead",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Vendor_Expert.getVendorCustomerHistory}`, {
        headers: {
          Authorization: `Bearer ${filter?.token}`,
        },
      });

      return res;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: error.message },
      );
    }
  },
);

export const Expert_Call = createAsyncThunk(
  "/expert-enquiry-call",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Vendor_Expert.Expert_Call, data);

      if (res?.success === false) {
        return rejectWithValue(res);
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: error.message },
      );
    }
  },
);

export const getExpertCustomerHistory = createAsyncThunk(
  "vendorexperts/expert-purchase-lead",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Vendor_Expert.getExpertCustomerHistory}`, {
        headers: {
          Authorization: `Bearer ${filter?.token}`,
        },
      });

      return res;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: error.message },
      );
    }
  },
);

export const availableToday = createAsyncThunk(
  "/available-today",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Vendor_Expert.availableToday, data);

      if (res?.success === false) {
        return rejectWithValue(res);
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: error.message },
      );
    }
  },
);

export const getAllNotification = createAsyncThunk(
  "vendorexperts/getnoti",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Vendor_Expert.getAllNotification}`, {
        headers: {
          Authorization: `Bearer ${filter?.token}`,
        },
      });

      return res;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: error.message },
      );
    }
  },
);

const subscriptionSlice = createSlice({
  name: "vendorexperts",
  initialState: {
    // plans: [],
    vendorPlans: [],
    expertPlans: [],
    history: [],
    vendorcustomerlist: [],
    expertcustomerlist: [],
    vendorcustomerhistory: [],
    expertcustomerhistory: [],
    allnotification: [],
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(getVendorExpert.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      // .addCase(getVendorExpert.fulfilled, (state, action) => {
      //   state.status = IDS.SLICESTATUS.Succeeded;

      //   const categories = action.payload?.data || [];

      //   state.plans = categories.flatMap((cat) => cat || []);
      // })
      .addCase(getVendorExpert.fulfilled, (state, action) => {
        const type = action.meta.arg.type;

        if (type === "vendor") {
          state.vendorPlans = action.payload.data || [];
        }

        if (type === "expert") {
          state.expertPlans = action.payload.data || [];
        }
      })

      .addCase(getVendorExpert.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload?.message;
      })

      .addCase(VendorEnquiry.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
        state.error = null;
      })
      .addCase(VendorEnquiry.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(VendorEnquiry.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload?.message || "Enquiry failed";
      })

      .addCase(ExpertEnquiry.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
        state.error = null;
      })
      .addCase(ExpertEnquiry.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(ExpertEnquiry.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload?.message || "Expert failed";
      })

      .addCase(RateUs.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
        state.error = null;
      })
      .addCase(RateUs.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(RateUs.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload?.message || "Rate Us failed";
      })

      .addCase(getVendorExpertList.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(getVendorExpertList.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.history = action.payload?.data || [];
      })

      .addCase(getVendorExpertList.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload?.message;
      })

      .addCase(getVendorCustomerList.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(getVendorCustomerList.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.vendorcustomerlist = action.payload?.data || [];
      })

      .addCase(getVendorCustomerList.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload?.message;
      })

      .addCase(getExpertCustomerList.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(getExpertCustomerList.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.expertcustomerlist = action.payload?.data || [];
      })

      .addCase(getExpertCustomerList.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload?.message;
      })

      .addCase(Vendor_Call.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
        state.error = null;
      })
      .addCase(Vendor_Call.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(Vendor_Call.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload?.message || "Rate Us failed";
      })

      .addCase(getVendorCustomerHistory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(getVendorCustomerHistory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.vendorcustomerhistory = action.payload?.data || [];
      })

      .addCase(getVendorCustomerHistory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload?.message;
      })

      .addCase(Expert_Call.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
        state.error = null;
      })
      .addCase(Expert_Call.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(Expert_Call.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload?.message || "Rate Us failed";
      })

      .addCase(getExpertCustomerHistory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(getExpertCustomerHistory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.expertcustomerhistory = action.payload?.data || [];
      })

      .addCase(getExpertCustomerHistory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload?.message;
      })

      .addCase(availableToday.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
        state.error = null;
      })
      .addCase(availableToday.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(availableToday.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload?.message || "Rate Us failed";
      })

      .addCase(getAllNotification.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(getAllNotification.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.allnotification = action.payload?.data || [];
      })

      .addCase(getAllNotification.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload?.message;
      });
  },
});

export default subscriptionSlice.reducer;
